module.exports = __webpack_public_path__ + "static/media/19ESCAP14.6b3290cd.jpg";